/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payabli/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import payabliPng from "./payabli.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payabli({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders/AddAction/Content/Payabli"
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let addProviderProviderValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'provider',
})
let constantData = 'payabli'
let aggregateData = fromAggregate.equals(addProviderProviderValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Payabli.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-1-12nrEF': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="add_provider.provider"
 data="'payabli'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 marginRight={0}
 paddingRight={0}
/>
<img
  data-testid="Payabli.Image"
  data-view-path={viewPath}
 alt={""}
 src={payabliPng}
 className={`views-block ${styles.Image}`}
/>
</div>
{children}
</React.Fragment>)
}